import { Button, Input, Radio, Select, Space, Divider } from "antd";
import NumericInput from "../numericInput";
import { PlusOutlined } from "@ant-design/icons";
import { useLocationFilter } from "../filters/useLocationFilter";
import { radiusList } from "../helper";

const FilterLocation = ({ talentFilter, talentData, talentFilterTags, onAddFilter }) => {
  const {
    zipValue,
    cityValue,
    radiusValue,
    selectedState,

    onZipChange,
    onRadiusChange,
    onStateChange,
    onCityChange,
    addLocationFilter
  } = useLocationFilter(talentFilter, talentData);

  const handleAdd = () => {
    const result = addLocationFilter(talentFilter, talentFilterTags);
    if (!result) return;

    onAddFilter("location", result);
  };

  return (
    <div className="px-[8px] py-[12px] location">
      <div>Select either Zip or City and State</div>

      <div className="border border-solid border-slate-200 mt-[5px]">
        <div className="p-[10px]">
          <h4 className="text-[11px] pb-[5px]">ZIP</h4>
          <NumericInput
            style={{ width: 120, border: 0 }}
            maxLength={5}
            value={zipValue}
            onChange={onZipChange}
            placeholder="Enter zip"
          />
        </div>

        <div className="border-t border-slate-200">
          <div className="p-[10px]">
            <h4 className="text-[11px] pb-[5px]">RADIUS (MILES)</h4>
            <Radio.Group onChange={onRadiusChange} value={radiusValue}>
              <Space direction="vertical">
                {radiusList.map((val, i) => (
                  <Radio key={i} value={val.value}>
                    {val.label}
                  </Radio>
                ))}
              </Space>
            </Radio.Group>
          </div>
        </div>
      </div>

      <Divider className="!text-xs">OR</Divider>

      <div className="border border-solid border-slate-200 mt-[10px] mb-[10px]">
        <div className="p-[10px] pb-[5px]">
          <h4 className="text-[11px] pb-[5px]">STATE</h4>
          <Select
            onChange={onStateChange}
            className="w-[180px]"
            placeholder="Select state"
            value={selectedState}
          >
            {talentData?.provinces?.map((val, i) => (
              <Select.Option value={val.uuid} key={i}>
                {val.name}
              </Select.Option>
            ))}
          </Select>
        </div>

        <div className="border-t border-slate-200">
          <div className="p-[10px]">
            <h4 className="text-[11px] pb-[5px]">CITY</h4>
            <Input
              style={{ width: 120, border: 0 }}
              value={cityValue}
              onChange={onCityChange}
              placeholder="Enter city"
            />
          </div>
        </div>
      </div>

      <div className="text-right">
        <Button
          disabled={
            (zipValue && radiusValue) || selectedState ? false : true
          }
          onClick={() => handleAdd()}
          icon={<PlusOutlined className="align-baseline" />}
        >
          Add Filter
        </Button>
      </div>
    </div>
  );
};

export default FilterLocation;
